export const SET_DOCUMENT_TYPES_SETTINGS_ERROR = 'SET_DOCUMENT_TYPES_SETTINGS_ERROR';
export const SET_DOCUMENT_TYPES_SETTINGS_LIST = 'SET_DOCUMENT_TYPES_SETTINGS_LIST';
export const SET_TOTAL_AMOUNT_OF_DOCUMENT_TYPES_SETTINGS = 'SET_TOTAL_AMOUNT_OF_DOCUMENT_TYPES_SETTINGS';
export const SET_FETCHING_DOCUMENT_TYPES_SETTINGS = 'SET_FETCHING_DOCUMENT_TYPES_SETTINGS';
export const SET_DOCUMENT_TYPES_SETTINGS_SHOW_MODAL = 'SET_DOCUMENT_TYPES_SETTINGS_SHOW_MODAL';
export const SET_DOCUMENT_TYPES_SETTINGS_ADD_ERROR = 'SET_DOCUMENT_TYPES_SETTINGS_ADD_ERROR';
export const SET_DOCUMENT_TYPES_SETTINGS_ADD_SUCCESS = 'SET_DOCUMENT_TYPES_SETTINGS_ADD_SUCCESS';
export const SET_DOCUMENT_TYPES_SETTINGS_ADD_FETCHING = 'SET_DOCUMENT_TYPES_SETTINGS_ADD_FETCHING';
